import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    keySeparator: '.',
    load: 'currentOnly',
    defaultNS: 'common',
    nsSeparator: ':',
    react: {
      useSuspense: true,
    },
  });

export default i18n;
